import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormularioDpsComponent } from './formulario-dps/formulario-dps.component';
import { FormSubmittedComponent } from './page/form-submitted/form-submitted.component';
import { LoginComponent } from './page/login/login.component';
import { NotFoundComponent } from './page/not-found/not-found.component';
import { TabelaRegistroComponent } from './page/tabela-registro/tabela-registro.component';

const routes: Routes = [
    {
        path: '',
        component: FormularioDpsComponent
    },
    {
        path: 'form-submitted',
        component: FormSubmittedComponent
    },
    {
        path: 'auth',
        component: LoginComponent
    },
    {
        path: 'registro',
        component: TabelaRegistroComponent
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: '**',
        redirectTo: '404',
        pathMatch: 'full'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
